import { Card, Descriptions, Drawer, Empty, Input, InputNumber, Select, Switch, Tag, notification } from "antd";
import { get } from "lodash";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";

const STATUS_MAP = {
  active: { label: "Actif", color: "green" },
  paused: { label: "En pause", color: "orange" },
  disconnected: { label: "Déconnecté", color: "red" },
  limit_reached: { label: "Limite atteinte", color: "orange" },
};

const SenderDetail = ({ sender, open, onClose, onRefetch }) => {
  const [updateSender] = useMutation(graphql.mutations.UPDATE_CRM_SENDER);

  if (!sender) return null;

  const saveField = async (field, value) => {
    try {
      await updateSender({
        variables: { where: { id: sender.id }, data: { [field]: value } },
      });
      if (onRefetch) onRefetch();
    } catch (err) {
      notification.error({ message: "Échec de la mise à jour" });
    }
  };

  const sm = STATUS_MAP[sender.status] || { label: sender.status, color: "default" };

  return (
    <Drawer
      title={sender.email}
      open={open}
      onClose={onClose}
      width={420}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Card size="small" title="Informations">
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div>
              <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Nom affiché</label>
              <Input defaultValue={sender.displayName} onBlur={(e) => saveField("displayName", e.target.value)} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Email</label>
              <Input defaultValue={sender.email} onBlur={(e) => saveField("email", e.target.value)} />
            </div>
            <div>
              <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Fournisseur</label>
              <Select defaultValue={sender.provider} style={{ width: "100%" }} onChange={(val) => saveField("provider", val)}>
                <Select.Option value="google">Google</Select.Option>
                <Select.Option value="outlook">Outlook</Select.Option>
                <Select.Option value="smtp">SMTP</Select.Option>
              </Select>
            </div>
            <div>
              <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>Statut</label>
              <Select defaultValue={sender.status} style={{ width: "100%" }} onChange={(val) => saveField("status", val)}>
                <Select.Option value="active">Actif</Select.Option>
                <Select.Option value="paused">En pause</Select.Option>
                <Select.Option value="disconnected">Déconnecté</Select.Option>
              </Select>
            </div>
          </div>
        </Card>

        <Card size="small" title="Limites & Envois">
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <div className="d-flex justify--between" style={{ alignItems: "center" }}>
              <span>Limite quotidienne</span>
              <InputNumber size="small" min={1} defaultValue={sender.dailyLimit}
                onBlur={(e) => saveField("dailyLimit", parseInt(e.target.value, 10) || 50)}
                style={{ width: 80 }} />
            </div>
            <div className="d-flex justify--between">
              <span>Envoyés aujourd'hui</span>
              <strong>{sender.sentToday} / {sender.dailyLimit}</strong>
            </div>
            <div className="d-flex justify--between">
              <span>Taux de rebond</span>
              <span style={{ color: sender.bounceRate > 5 ? "#eb5757" : sender.bounceRate > 3 ? "#f2994a" : "#27ae60", fontWeight: 600 }}>
                {sender.bounceRate || 0}%
              </span>
            </div>
            <div className="d-flex justify--between">
              <span>Réputation</span>
              <Tag color={sender.reputation === "good" ? "green" : sender.reputation === "warning" ? "orange" : "red"}>
                {sender.reputation || "—"}
              </Tag>
            </div>
          </div>
        </Card>

        <Card size="small" title="Warm-up">
          <Descriptions column={1} size="small">
            <Descriptions.Item label="Statut">{sender.warmupStatus || "—"}</Descriptions.Item>
            <Descriptions.Item label="Jour">{sender.warmupDay || "—"}</Descriptions.Item>
          </Descriptions>
        </Card>

        <Card size="small" title="Campagnes assignées">
          {(sender.assignedCampaignIds || []).length === 0
            ? <Empty description="Aucune campagne" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            : <div>{(sender.assignedCampaignIds || []).map((cid) => <Tag key={cid}>{cid}</Tag>)}</div>
          }
        </Card>
      </div>
    </Drawer>
  );
};

export default SenderDetail;
